export default __webpack_public_path__ + "791f8e7d1704aaaf55461832c2442db1.png";